import {useTranslation} from "react-i18next";
import {Page} from "../components/common";
import {Container, Typography} from "@mui/material";
import {Scheduler} from "../components/scheduling";

export const SchedulePage = () => {
    const {t} = useTranslation(['navigation']);
    const title = t('schedule');
    return <Page title={`${title} | Kocha`}>
        <Container maxWidth="xl">
            <Typography variant="h4">{title}</Typography>
            <Scheduler onSelectEvent={(p: any) => {
                console.log("PPPP", p.title);
            }}/>
        </Container>
    </Page>
}
